/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import Header from '../Header';
import Sidebar from '../Sidebar';
import LoadFooter from '../Footer';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    lowIe: PropTypes.bool,
    mycourseDisabled: PropTypes.bool,
    loginDisabled: PropTypes.bool,
    hasSidebar: PropTypes.bool,
    hasFooter: PropTypes.bool,
  };
  static defaultProps = {
    lowIe: false,
    mycourseDisabled: false,
    loginDisabled: false,
    hasSidebar: true,
    hasFooter: true,
  };

  render() {
    const {
      children,
      lowIe,
      mycourseDisabled,
      loginDisabled,
      hasSidebar,
      hasFooter,
    } = this.props;

    return (
      <div>
        <Header
          lowIe={lowIe}
          mycourseDisabled={mycourseDisabled}
          loginDisabled={loginDisabled}
        />
        {children}
        {lowIe || !hasSidebar ? null : <Sidebar />}
        {hasFooter ? <LoadFooter /> : null}
      </div>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);



// WEBPACK FOOTER //
// ./src/components/global/Layout/index.js